import React from 'react';
import { withTranslation } from 'react-i18next';
//settings
import { SETTINGS } from 'refactored/features/emergencies/constants';
//components
import HeaderColumn from 'refactored/features/emergencies/ui/columns/header-olumn';
import EndColumnsContainer from 'refactored/features/emergencies/ui/containers/end-columns-container';
import StartColumnsContainer from 'refactored/features/emergencies/ui/containers/start-columns-container';
import HeaderRow from 'refactored/features/emergencies/ui/rows/header-row';
import HeaderText from 'refactored/features/emergencies/ui/texts/header-text';

const columnWidths = SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX;

const TicketsListTableHeaderRow = ({ t }) => {
  const headerColumns = {
    startColumns: [
      {
        width: columnWidths.TICKET,
        text: t('ticket'),
      },
      {
        width: columnWidths.LOCATIONS,
        text: t('locations'),
      },
      {
        width: columnWidths.SERVICE,
        text: t('service'),
        centerContent: true,
      },
      {
        width: columnWidths.LOAD,
        text: t('load'),
        centerContent: true,
      },
      {
        width: columnWidths.QUOTE,
        text: t('quote'),
        centerContent: true,
      },
    ],
    endColumns: [
      {
        width: columnWidths.OWNER,
        text: t('owner_agent'),
        centerContent: true,
      },
    ],
  };
  return (
    <HeaderRow>
      <StartColumnsContainer>
        {headerColumns.startColumns.map((column, index) => (
          <HeaderColumn
            key={index}
            width={column.width}
            centerContent={!!column.centerContent}
          >
            <HeaderText>{column.text}</HeaderText>
          </HeaderColumn>
        ))}
      </StartColumnsContainer>
      <EndColumnsContainer>
        {headerColumns.endColumns.map((column, index) => (
          <HeaderColumn
            key={index}
            width={column.width}
            centerContent={!!column.centerContent}
          >
            <HeaderText>{column.text}</HeaderText>
          </HeaderColumn>
        ))}
      </EndColumnsContainer>
    </HeaderRow>
  );
};

export default withTranslation('Emergencies')(TicketsListTableHeaderRow);
